import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { filter, Subscription } from 'rxjs';

import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { InvoicingService } from 'src/app/services/invoicing/invoicing.service';
import { LocationService } from 'src/app/services/location/location.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { ProviderService } from 'src/app/services/provider/provider.service';

import { BaseInvoiceComponent } from './base.invoice.component';
import { ChannelType } from 'src/app/models/transaction-enums.model';
import { ApplicationStateService } from 'src/app/services/application-state.service';
import { LoadingService } from '../../core/services/loading/loading.service';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
})
export class InvoiceComponent
  extends BaseInvoiceComponent
  implements OnInit, OnDestroy
{
  public showPayButtonStatus: boolean | undefined;
  private unsubscribe$: Subscription = new Subscription();

  constructor(
    @Inject('INVOICE_TRACKING_KEY') private invoiceTrackingKey: string,
    private route: ActivatedRoute,
    protected invoiceService: InvoiceService,
    protected invoicingService: InvoicingService,
    protected locationService: LocationService,
    protected transactionService: TransactionService,
    protected providerService: ProviderService,
    private router: Router,
    private applicationState: ApplicationStateService,
    private loadingService: LoadingService
  ) {
    super(
      invoiceService,
      invoicingService,
      locationService,
      transactionService,
      providerService
    );
  }

  ngOnInit(): void {

    const sub = this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.applicationState.currentStep == '' && this.initialize();
      });
    this.unsubscribe$.add(sub);

    this.initialize();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.unsubscribe();
  }

  private initialize() {

    this.loadingService.attach();

    const sub = this.getInvoiceDetails(
      this.invoiceTrackingKey,
      this.invoiceViewed()
    ).subscribe(() => {
      this.showPayButtonStatus = this.getPayButtonStatus(
        this.transactionService.transaction.transactionStatusTypeId
      );

      this.setBrandColors(
        this.invoicingService.invoicing.primaryBrandColor,
        this.invoicingService.invoicing.secondaryBrandColor
      );
    }).add(() => this.loadingService.deattach());

    this.unsubscribe$.add(sub);
  }

  private invoiceViewed = () =>
    this.route.snapshot.queryParams?.chid !== ChannelType.Merchant.toString();

  private setBrandColors(primary: string, secondary: string): void {
    document.documentElement.style.setProperty(
      '--primary-brand',
      `#${primary}`
    );
    document.documentElement.style.setProperty(
      '--secondary-brand',
      `#${secondary}`
    );
  }
}
